import React from "react";
import ModalSelecionar from "./ModalSelecionar";

const COLUNAS = [
  { header: "Código", render: (p) => p.codigo ?? "—", destaque: true },
  { header: "Imóvel", render: (p) => p.imovel?.apelido ?? p.enderecoImovel ?? "—" },
  { header: "Status", render: (p) => p.statusGeral ?? "—" },
];

export default function ModalSelecionarProposta(props) {
  return (
    <ModalSelecionar titulo="Selecionar Proposta" endpoint="/api/propostas/selecao" placeholder="Código, endereço ou imóvel…" colunas={COLUNAS} {...props} />
  );
}
